<div>
    <img [src]="icon" alt="icon" />
</div>
